export default __webpack_public_path__ + "static/media/angry.6d2d60d3.png";